/**
 * I'll make sure something happens, but not too often
 *
 * You've all seen it: A function gets called way too often due to some repeated
 * event. How to deal with it? Well, why not just wait until the torrent of
 * identical events are over, and THEN handle it?
 *
 * @param {Function} func A function to call when the dust has settled
 * @param {Number} wait The number of milliseconds to wait before triggering `func`
 * @param {Boolean} immediate If TRUE then trigger `func` on the FIRST event
 * @return {Function} A function you can call as often as you want
 */
export function debounce(func, wait, immediate = false) {
	let timeout
	return function () {
		const context = this, args = arguments
		const later = function () {
			timeout = null
			if (!immediate) func.apply(context, args)
		}
		const callNow = immediate && !timeout
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
		if (callNow) func.apply(context, args)
	}
}